import React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid } from "@mui/material";
import CategoryImg from "../images/category.svg";
import updateImg from "../images/update.svg";
import FilltersImg from "../images/fillters.svg";
import ExploreJobImg from "../images/Expolor_Jobs.svg";
import DiscountImg from "../images/discounts.svg";
import PromotionalImg from "../images/Promotional.svg";

import useStyles from "../css/servicesStyle.js"; 

export default function Services() {
  const classes = useStyles;  // Use the styles

  return (
    <Container>
      <Box id="Features" sx={classes.container}>
        <Typography variant="h2" sx={classes.heading}> {/* Change this to use sx prop */}
          Sign up easily with email authentication for: 
        </Typography>
        <Typography variant="body1" sx={classes.subHeading}> {/* Change this to use sx prop */}
          Experience the power of AMBD - Australian Muslim Business Directory. Download now and support Muslim-owned businesses and services in Australia!
        </Typography>
        <Box sx={classes.divider}></Box> {/* Change this to use sx prop */}
      </Box>
      
      <Grid container mb={5} sx={{ mt: 6, pb: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Grid container item lg={10} md={10} sm={12} xs={12} mb={5} spacing={7}>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="CategoryImg" src={CategoryImg} />
                </Box>
              </Box>
              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Various Business Categories
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Browse businesses by categories and subcategories such as Muslim Tradies, Halal food services, Muslim Medical services, migration, Nikah services, Islamic schools and colleges all over Australia.                
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="updateImg" src={updateImg} />
                </Box>
              </Box>              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Stay Updated
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Access exclusive deals and offers with featured promotional ads.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="FilltersImg" src={FilltersImg} />
                </Box>
              </Box>
              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Smart Filters by Cities
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Find local businesses and jobs with precision using city-based filters.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="ExploreJobImg" src={ExploreJobImg} />
                </Box>
              </Box>
              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Explore Jobs
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Discover job openings across diverse Small Muslim Business’s and Australia-wide.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="DiscountImg" src={DiscountImg} />
                </Box>
              </Box>
              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Exclusive Discounts
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Enjoy budget-friendly purchases with exclusive discounts.                
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Box sx={classes.box}> {/* Change this to use sx prop */}
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={classes.boxImg}>
                    <Box component="img" sx={classes.img} alt="PromotionalImg" src={PromotionalImg} />
                </Box>
              </Box>
              <Box>
                <Typography variant="h5" sx={classes.title}> {/* Change this to use sx prop */}
                  Promotional Banner
                </Typography>
                <Typography variant="body1" sx={classes.description}> {/* Change this to use sx prop */}
                  Shine your Business on top of AMBD 
                   visible whenever the App is used                
                </Typography>
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Grid>
    </Container>
  );
}
